import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function FaqAccordion({ items }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="border-t border-white/10" data-testid="faq-accordion">
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={item.q} className="border-b border-white/10">
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? -1 : i)}
              className="w-full flex items-start justify-between gap-6 text-left py-6 md:py-8 group"
              aria-expanded={isOpen}
              data-testid={`faq-item-${i}`}
            >
              <span className={`font-anton uppercase text-2xl md:text-4xl tracking-tight transition-colors ${isOpen ? "text-[#2A5BFF]" : "text-white group-hover:text-[#2A5BFF]"}`}>
                {item.q}
              </span>
              <span className="w-10 h-10 shrink-0 border border-white/15 flex items-center justify-center mt-1 group-hover:border-[#2A5BFF] transition-colors">
                {isOpen ? <Minus size={16} /> : <Plus size={16} />}
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  key="body"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="pb-8 text-white/60 max-w-2xl text-base leading-relaxed">
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
